(function () {
  angular
    .module("akitabox.asset.list")
    .controller("AssetListController", AssetListController);

  /* @ngInject */
  function AssetListController(
    $scope,
    $location,
    $state,
    models,
    building,
    organization,
    query,
    AssetService,
    PinValueService
  ) {
    var self = this;

    var filter = AssetService.getBuildingListFilter(building._id) || {};
    var baseQuery = {
      include_values: true,
    };

    self.searchText = null;
    self.building = building;
    self.assets = null;
    self.organization = organization;

    self.hasLoaded = hasLoaded;
    self.emptyList = emptyList;
    self.selectAsset = selectAsset;

    // Functions
    self.getRoomPinValue = PinValueService.getRoomPinValue;
    self.addWorkOrder = addWorkOrder;
    self.addServiceRequest = addServiceRequest;

    init();

    function init() {
      // Initialize search. Default to querystring, then cached filter
      self.searchText = query ? query : filter.q;
      fetchAssets(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);
      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchChangeText, 500));
    }

    function addServiceRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.serviceRequests.create", params);
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.workOrders.create", params);
    }

    function onSearchChangeText(newValue, oldValue) {
      if (newValue !== oldValue && !angular.isEmpty(newValue)) {
        fetchAssets(newValue);
      } else if (newValue !== oldValue) {
        fetchAssets();
      }
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
      AssetService.setBuildingListFilter(building._id, filter);
    }

    function fetchAssets(text) {
      $location.search("q", text);
      if (text) {
        // New filter option for BFF
        updateFilter({ $or: `name=${text};` });
      } else {
        if (filter) {
          // Cleaning filter to avoid cached data filtered
          filter = {};
        }
      }

      var additionalParams = { building: building._id };
      var params = angular.extend({}, baseQuery, filter, additionalParams);
      self.assets = AssetService.getVirtualRepeat(
        building.organization,
        100,
        params
      );
    }

    function selectAsset(asset) {
      $state.go("app.building.asset.detail", { assetId: asset._id });
    }

    function hasLoaded() {
      return angular.isNumber(self.assets.numItems);
    }

    function emptyList() {
      return (
        self.assets.getLength() === 0 &&
        !self.assets.moreToLoad &&
        !self.assets.fetching
      );
    }
  }
})();
